// URL
export const API_URL = import.meta.env.VITE_API_URL;
export const SOLR_API_URL = import.meta.env.VITE_SOLR_API_URL;
export const BILLING_PORTAL_URL = import.meta.env.VITE_BILLING_PORTAL_URL;

export const ADMIN_TOP_PATH = import.meta.env.DEV
  ? 'http://localhost:5174/admin'
  : '/admin';

// user.summarizedRole
const SUMMARIZED_SYSTEM_ADMIN_ROLE = 'system_admin';
const SUMMARIZED_MEMBER_ROLE = 'institution_member';
const SUMMARIZED_ADMIN_ROLE = 'institution_admin';
const SUMMARIZED_MEMBER_AND_ADMIN_ROLE = 'institution_member_and_admin';
export const SUMMARIZED_N0NE_ROLE = 'none';

export const SUMMARIZED_ADMIN_ROLES = [
  SUMMARIZED_ADMIN_ROLE,
  SUMMARIZED_MEMBER_AND_ADMIN_ROLE,
  SUMMARIZED_SYSTEM_ADMIN_ROLE,
] as const;

export const SUMMARIZED_MEMBER_ROLES = [
  SUMMARIZED_MEMBER_ROLE,
  SUMMARIZED_MEMBER_AND_ADMIN_ROLE,
  SUMMARIZED_SYSTEM_ADMIN_ROLE,
] as const;

export const SUMMARIZED_ROLES = [
  ...new Set([
    SUMMARIZED_N0NE_ROLE,
    ...SUMMARIZED_ADMIN_ROLES,
    ...SUMMARIZED_MEMBER_ROLES,
  ]),
] as const;

// license_type codes (backend 定義に対応)
export const LICENSE_TYPE = {
  BASIC: 'a',
  PLUS: 'b',
  EDU: 'c',
  BIZ: 'd',
} as const;

export type LicenseType = (typeof LICENSE_TYPE)[keyof typeof LICENSE_TYPE];

export const LICENSE_TYPES = Object.values(
  LICENSE_TYPE
) as readonly LicenseType[];

// リクエスト時にCase変換しないパラメータ
export const PRESERVED_PARAM_KEYS = ['q.op', 'json.nl'];

// subscription
export const AVAILABLE_RECURRING_INTERVALS = ['month', 'year'] as const;
export const AVAILABLE_CURRENCIES = ['jpy', 'usd'] as const;

// Dialog
export const DIALOG_LEAVE_ANIMATION_DURATION = 200;

// FeatureKeys
// TODO: 他のキーもこちらで管理するようにする
export const FeatureKeys = {
  searchTranslation: 'search_translation',
  downloadArticles: 'download_articles',
  treemap: 'treemap',
  transition: 'transition',
  saveFilters: 'save_filters',
} as const;

// Max Search word length
export const MAX_SEARCH_KEYWORD_LENGTH = 100;
